import Storage from 'react-native-storage';
import AsyncStorage from '@react-native-async-storage/async-storage';

const storage = new Storage({
  storageBackend: AsyncStorage
});

export { storage };

/**
 * ストレージデータの保存
 * @param keys string
 * @param data {}
 */
export async function saveStorage(keys: string, data: any) {
  return storage.save({
    key: keys,
    data: data,
  });
}

/**
 * ストレージデータの取得
 * @param keys 
 * @returns 
 */
export async function getStorage(keys: string) {
  return storage.load({ key: keys }
  ).then(res => {
    return res;
  }).catch(err => {
    switch (err.name) {
      case 'NotFoundError':
        // キーが見つからない場合
        break;
      case 'ExpiredError':
        // キャッシュ切れの場合
        console.warn(err.message);
        break;
      default:
        console.warn(err.message);
        break;
    }
  }
  );
}

/**
 * ストレージデータの削除
 * @param keys 
 * @returns 
 */
export async function removeStorage(keys: string) {
  storage.remove({ key: keys }).then(res => {
    return res;
  }).catch(err => {
    console.warn(err);
  });
}

/**
 * ストレージデータの全削除
 */
export async function allRemoveStorage() {
  AsyncStorage.getAllKeys().then(res => {
    res.forEach((data: any) => {
      storage.remove({ key: data });
    });
  }).catch(error => {
    console.warn(error);
  });
}